import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get } from 'lodash';
import React from 'react';
import { Form, OriSelect, RadioGroup, RadioItem } from 'src/components/Antd';
import Section from 'src/pages/SalesCannelVersion/Components/SectionContainer';
import css from './css.module.less';
import Card, { EApplyTo, EProductsMatchRule, EType } from './EligibleCard';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const List = Form.List;
const Item = Form.Item;
export enum ECondition {
  And = 'And',
  Or = 'Or',
}
const OrderCondition = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { name, form, currency, disableEdit } = props;
  const listName = [name, 'conditions'];
  const radioName = [name, 'enabled'];
  const selectName = [name, 'condRelation'];

  return (
    <React.Fragment>
      <Section bottomBorder className={css.section}>
        <Item name={radioName}>
          <RadioGroup
            className={css.radioGroup}
            rules={[{ required: true }]}
            disabled={disableEdit}>
            <RadioItem value={false} className={css.radio}>
              {getI18n('general.status.none')}
            </RadioItem>
            <RadioItem value={true} className={css.radio}>
              {getI18n(
                'salesChannelDirectDiscount.eligibalCondition.applyCondition',
              )}
            </RadioItem>
          </RadioGroup>
        </Item>
        <Item
          shouldUpdate={(p, c) => {
            const pV = get(p, radioName);
            const cV = get(c, radioName);
            return pV !== cV;
          }}>
          {({ getFieldValue }) => {
            const isDisplay = getFieldValue(radioName);
            if (isDisplay) {
              return (
                <div className={css.selectContainer}>
                  <ItemWrapper
                    title={getI18n(
                      'salesChannelDirectDiscount.eligibalCondition.conditionsCalculationRule',
                    )}
                    containerClassName={css.itemWrapperContainerClassName}>
                    <Item
                      name={selectName}
                      rules={[
                        {
                          required: true,
                          message: getI18n('general.pleaseselectthevalue'),
                        },
                      ]}>
                      <OriSelect size='large' disabled={disableEdit}>
                        <OriSelect.Option value={ECondition.Or}>
                          {getI18n(
                            'salesChannelDirectDiscount.eligibalCondition.oR(meetanyoftheconditions)',
                          )}
                        </OriSelect.Option>
                        <OriSelect.Option value={ECondition.And}>
                          {getI18n(
                            'salesChannelDirectDiscount.eligibalCondition.aND(meetalloftheconditions)',
                          )}
                        </OriSelect.Option>
                      </OriSelect>
                    </Item>
                  </ItemWrapper>
                </div>
              );
            }
          }}
        </Item>
      </Section>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, radioName);
          const cV = get(c, radioName);
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const isDisplay = getFieldValue(radioName);
          if (isDisplay) {
            return (
              <div className={css.container}>
                <List
                  name={listName}
                  rules={[
                    {
                      validator: async (_, names) => {
                        if ((names || []).length < 1) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'general.commonRadioMulSelect.pleaseselectatleastoneitem',
                              ),
                            ),
                          );
                        }
                      },
                    },
                  ]}>
                  {(fields, { add, remove }, { errors }) => {
                    const canDelete = fields.length > 1;
                    const disableAdd = fields.length > 2;
                    const handleOnRemove = (index) => {
                      remove(index);
                    };
                    // console.log('fields', fields);
                    return (
                      <div className={css.fieldContainer}>
                        {fields.map((i, index) => {
                          return (
                            <Card
                              currency={currency}
                              key={index}
                              fields={fields}
                              listName={listName}
                              canDelete={canDelete}
                              disableEdit={disableEdit}
                              index={index}
                              form={form}
                              onRemove={() => {
                                handleOnRemove(index);
                              }}
                            />
                          );
                        })}
                        {!disableAdd && !disableEdit && (
                          <div
                            className={css.addContainer}
                            onClick={() => {
                              add({
                                basedOn: EType.Value,
                                applyTo: EApplyTo.All,
                                matchRule: EProductsMatchRule.Any,
                                collections: [],
                                products: [],
                              });
                            }}>
                            +{' '}
                            {getI18n(
                              'salesChannelDirectDiscount.eligibalCondition.addEligibleCondition',
                            )}
                          </div>
                        )}

                        {(errors || []).length > 0 && (
                          <div className={css.errorContainer}>
                            <Form.ErrorList errors={errors} />
                          </div>
                        )}
                      </div>
                    );
                  }}
                </List>
              </div>
            );
          }
          return null;
        }}
      </Item>
    </React.Fragment>
  );
};
export default OrderCondition;
